import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSubscribers from '../../components/subscribers/list-subscribers.component';

const SubscribersView = () => {
  const pageTitle = 'Manage Users / All Users';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListSubscribers />
    </AppLayout>
  );
};

export default SubscribersView;
